module.exports = __webpack_public_path__ + "static/media/cardicon.f26765a6.svg";